import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { ScoreLogicListing } from './components/ScoreLogicListing';
import { NewScoreLogicDrawer } from './components/NewScoreLogicDrawer';

export type ManageScoreLogicProps = {
  organizationId: string;
};

export const ManageScoreLogics = ({
  organizationId,
}: ManageScoreLogicProps) => {
  const [showDrawer, setShowDrawer] = useState(false);

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/score_logic`
        : '/organizations',
    },
    {
      label: 'Score Logic',
      href: `/organization/${org?.id}/score_logic`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Score Logics</h2>
          <p className="text-muted-foreground">
            {`List of score logics for ${org?.name}.`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowDrawer(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      <div className="mt-4 max-w-4xl">
        <ScoreLogicListing />
      </div>

      {/* Create New Score Logic Drawer */}
      <NewScoreLogicDrawer
        open={showDrawer}
        setOpen={setShowDrawer}
        // organizationId={org?.id || organizationId}
      />
    </div>
  );
};